const Intro = () => {
  return (
    <div className="flex flex-col flex-1 p-4">
      <section
        id="intro"
        className="grid grid-cols-1 lg:grid-cols-2 gap-10 py-10 sm:py-8"
      >
        <div className="flex flex-col lg:justify-center text-left lg-text-left gap-6 md:gap-8 lg:gap-10">
          <h2 className="font-semibold text-4xl sm:text-5xl md:text-5xl">
            Hi! I'm <span className="poppins text-violet-400">Nahid</span>{" "}
            Raihan <br />
            Full Stack{" "}
            <span className="poppins text-violet-400">Developer</span> with a{" "}
            <span className="poppins text-violet-400">finance</span> background,
          </h2>
          <p className="font-newsreader text-2xl font-semibold sm:text-lg md:text-xl">
            Unique blend of <span className="text-violet-400">tech skills</span>{" "}
            and <span className="text-violet-400">business acumen</span>,
            transforming client needs into effective software solutions aligned
            with business goals.
          </p>
          <a
            href="https://drive.google.com/file/d/12VQbmxNaYHsYArwW9PQR-lHMRzPZlXAm/view?usp=sharing"
            target="_blank"
            className="blueShadow mx-auto mt-6 lg:mr-auto text-base sm:text-lg md:text-xl
      poppins relative overflow-hidden px-6 py-3 group rounded-full bg-white text-violet-900 font-semibold hover:bg-violet-300"
            data-aos="fade-right" rel="noreferrer"
          >
            <div
              className="absolute top-0 right-full width-full h-full bg-violet-400 opacity-20 group-hover:translate-x-full z-0 duration-200"
              data-aos="fade-right"
            />
            <h4 className="relative z-9">Download My Resume</h4>
          </a>
          {/* social media div */}
        </div>
        <div className="relative shadow-2xl grid place-items-center">
          <img
            src={"./Nahid_wearing_panjabi-removebg-preview.jpg"}
            alt="Profile Pic"
            className="rounded-full object-cover z-[2] max-h-[60vh]"
            data-aos="fade-left"
            data-aos-anchor="#example-anchor"
            data-aos-offset="500"
            data-aos-duration="500"
          />
          <div className="flex flex-row grid grid-cols-5 gap-4">
            <a
              href="https://www.linkedin.com/in/nahidraihan/"
              target="_blank"
              className="blueShadow mx-auto w-full lg:mr-auto text-base sm:text-lg md:text-xl
      poppins relative overflow-hidden px-2 py-3 group rounded-full bg-white text-slate-950 hover:bg-violet-300"
              data-aos="fade-right" rel="noreferrer"
            >
              <i class="fa-brands fa-linkedin-in fa-bounce" style={{color: "#300782",}}></i>
            </a>
            <a
              href="https://www.facebook.com/nahid.sardar"
              target="_blank"
              className="blueShadow mx-auto w-full lg:mr-auto text-base sm:text-lg md:text-xl
      poppins relative overflow-hidden px-2 py-3 group rounded-full bg-white text-slate-950"
              data-aos="fade-right" rel="noreferrer"
            >
              <i class="fa-brands fa-facebook-f fa-beat" style={{color: "#300782",}}></i>
            </a>
            <a
              href="https://github.com/Nahid1911"
              target="_blank"
              className="blueShadow mx-auto w-full lg:mr-auto text-base sm:text-lg md:text-xl
      poppins relative overflow-hidden px-2 py-3 group rounded-full bg-white text-slate-950"
              data-aos="fade-right" rel="noreferrer"
            >
              <i class="fa-brands fa-github fa-bounce" style={{color: "#300782",}}></i>
            </a>
            <a
              href="https://medium.com/@nahid.raihan"
              target="_blank"
              className="blueShadow mx-auto w-full lg:mr-auto text-base sm:text-lg md:text-xl
      poppins relative overflow-hidden px-2 py-3 group rounded-full bg-white text-slate-950"
              data-aos="fade-right" rel="noreferrer"
            >
              <i class="fa-brands fa-medium fa-flip" style={{color: "#300782",}}></i>
            </a>
            <a
              href="https://www.youtube.com/@nahidraihan"
              target="_blank"
              className="blueShadow mx-auto w-full lg:mr-auto text-base sm:text-lg md:text-xl
      poppins relative overflow-hidden px-2 py-3 group rounded-full bg-white text-slate-950"
              data-aos="fade-right" rel="noreferrer"
            >
              <i class="fa-brands fa-youtube fa-beat" style={{color: "#300782",}}></i>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Intro;
